module.exports = __webpack_public_path__ + "media/images/arrow-down-02-d676315eb04a9bab431e692dd1166577.svg";